import React, { useContext } from 'react';
import { BsFillMoonFill, BsFillSunFill } from 'react-icons/bs';
import { ThemeContext } from '../../../contexts/theme-context';
import './change-theme.css';

const ChangeTheme = () => {
  const { changeTheme, isDark } = useContext(ThemeContext);
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <button
      type='button'
      className='themeToggle'
      onClick={changeTheme}
      aria-label={label}
      title={label}
    >
      {isDark ? <BsFillSunFill aria-hidden='true' /> : <BsFillMoonFill aria-hidden='true' />}
    </button>
  );
};

export default ChangeTheme;
